import {ModelGroup} from '../../model-group/model-group.model';
import {Brand} from '../../brand/brand.model';

export class AgeMileageConfiguration {
  id: number;
  category: string;
  kilometrage: number;
  age: number;
  brand: Brand;

}
